import React, { Component } from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

class FormCreate extends Component {

    handleSubmit = e => {
        e.preventDefault();
    };

    render() {
        return (
            <React.Fragment>
                <Modal isOpen={this.props.modal} toggle={this.props.toggle} className="modal-dialog-centered" backdrop={this.props.backdrop}>
                    <ModalHeader toggle={this.props.toggle}><i className="app-menu__icon fa fa-user mr-2"></i> {this.props.title}</ModalHeader>

                        <form onSubmit={this.handleSubmit}>
                            <ModalBody>
                                <div className="row">

                                    <div className="col-md-6">
                                        <label>Nombre <small className="validate-label">*</small></label>
                                        <input
                                            type="text"
                                            name="name"
                                            value={this.props.formValues.name}
                                            onChange={this.props.onChangeForm}
                                            className={`form form-control ${this.props.errorValues == false && this.props.formValues.name == "" ? "error-class" : ""}`}
                                            placeholder="Nombre"
                                        />
                                    </div>


                                    <div className="col-md-6">
                                        <label>Tipo <small className="validate-label">*</small></label>
                                        <select 
                                            name="proceso_type" 
                                            value={this.props.formValues.proceso_type}
                                            onChange={this.props.onChangeForm}
                                            className={`form form-control`}
                                        >

                                            <option value="">Tipo de proceso</option>
                                            {this.props.tenant.app_type == "Salud" ? (
                                                <React.Fragment>
                                                    <option value="procesos administrativos">Administrativo</option>
                                                    <option value="procesos clinicos">Clínico</option>
                                                </React.Fragment>
                                            ) : (
                                                <React.Fragment>
                                                    <option value="Estratégico">Administrativo</option>
                                                    <option value="Operativo">Operativo</option>
                                                    <option value="Apoyo">Apoyo</option>
                                                    <option value="Gestión">Gestión</option>
                                                </React.Fragment>
                                            )}

                                        </select>
                                    </div>

                                    <div className="col-md-12 mt-2 mb-2">
                                        <label>Prefijo</label>
                                        <input
                                            type="text"
                                            name="prefix"
                                            value={this.props.formValues.prefix}
                                            onChange={this.props.onChangeForm}
                                            className={`form form-control ${this.props.errorValues == false && this.props.formValues.name == "" ? "error-class" : ""}`}
                                            placeholder=""
                                        />
                                    </div>

                                    <div className="col-md-12 mt-4">
                                        <textarea 
                                            name="description" 
                                            value={this.props.formValues.description}
                                            onChange={this.props.onChangeForm}
                                            placeholder="Descripción"
                                            className={`form form-control`}
                                            rows="8">
                                        </textarea>
                                    </div>
                                    
                                    {this.props.errorValues == false && (
                                        <div className="col-md-12 mt-4">
                                            <div className="alert alert-danger" role="alert">
                                            <b>Debes de completar todos los campos requeridos</b>
                                            </div>
                                        </div>
                                    )}

                                </div>
                            </ModalBody>

                            <ModalFooter>
                                <label className="btn btn-light mt-2" onClick={() => this.props.toggle()}>Cerrar</label>
                                <button className="btn-shadow btn btn-info" onClick={this.props.submitForm}>{this.props.nameSubmit}</button>
                            </ModalFooter>
                        </form>
                </Modal>
            </React.Fragment>
        );
    }
}

export default FormCreate;